// src/SideBar.jsx

import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { BsFillLightningFill, BsGearFill } from 'react-icons/bs';
import { IoIosCreate } from 'react-icons/io';
import SkullIcon from './SkullIcon';

// A single rail destination: rose-gradient pill when active, subtle hover
// otherwise, with a tooltip that reveals the label on hover.
const RailItem = ({ to, icon, label, end }) => (
  <NavLink to={to} end={end} className="group relative flex justify-center" aria-label={label}>
    {({ isActive }) => (
      <>
        <span
          className={`flex h-11 w-11 items-center justify-center rounded-2xl transition-all duration-200 ${
            isActive
              ? 'bg-gradient-to-br from-rose-500 to-pink-600 text-white shadow-lg shadow-rose-500/25'
              : 'text-white/50 hover:bg-white/5 hover:text-white'
          }`}
        >
          {icon}
        </span>
        <span className="pointer-events-none absolute left-[52px] top-1/2 z-50 -translate-y-1/2 whitespace-nowrap rounded-lg border border-white/10 bg-gray-900 px-2.5 py-1 text-xs font-medium text-white opacity-0 shadow-xl transition-opacity duration-150 group-hover:opacity-100">
          {label}
        </span>
      </>
    )}
  </NavLink>
);

const SideBar = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return null;

  return (
    <aside className="fixed left-0 top-0 z-50 hidden h-screen w-16 flex-col items-center border-r border-white/10 bg-gray-900 py-4 md:flex">
      {/* Brand */}
      <NavLink
        to="/browse"
        className="flex h-11 w-11 items-center justify-center rounded-2xl text-rose-500 transition-colors hover:bg-white/5"
        aria-label="Home"
      >
        <SkullIcon size={31} className="translate-y-[2px]" />
      </NavLink>

      <div className="my-3 h-px w-8 bg-white/10" />

      {/* Primary nav */}
      <nav className="flex flex-1 flex-col items-center gap-1.5">
        <RailItem to="/" end icon={<IoIosCreate size={24} />} label="Create" />
        {user && (
          <RailItem
            to={`/userpage/${user.username}`}
            icon={<BsFillLightningFill size={18} />}
            label="Your designs"
          />
        )}
      </nav>

      {/* Settings pinned to bottom */}
      <RailItem to="/settings" icon={<BsGearFill size={19} />} label="Settings" />
    </aside>
  );
};

export default SideBar;
